import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderuiService } from '../../Services/loaderui.service';

@Component({
  selector: 'app-loaderspin',
  templateUrl: './loaderspin.component.html',
  styleUrls: ['./loaderspin.component.scss']
})
export class LoaderspinComponent implements OnInit {
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(private loaderService: LoaderuiService){}

  ngOnInit(): void {
  }

}
